import { useState } from 'react';
import { Link, NavLink, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import ConsoleIcon from './ConsoleIcons';
import { NAV_GROUPS, PAGE_TITLES } from './navConfig';
import './Console.css';
import Overview from './views/Overview';
import Playground from './views/Playground';
import Tokens from './views/Tokens';
import Logs from './views/Logs';
import Models from './views/Models';
import Recharge from './views/Recharge';
import Profile from './views/Profile';
import Wallet from './views/Wallet';
import Referral from './views/Referral';

const ConsoleLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const section = location.pathname.split('/').pop() || 'overview';
  const pageTitle = PAGE_TITLES[section] || '控制台';

  return (
    <div className="console">
      <aside className={`console-sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="console-sidebar-header">
          <Link to="/console/overview" className="console-brand">
            <span className="console-brand-icon">T</span>
            {!collapsed && <span>TokenAI</span>}
          </Link>
          <button
            type="button"
            className="console-collapse-btn"
            onClick={() => setCollapsed((c) => !c)}
            aria-label={collapsed ? '展开侧边栏' : '收起侧边栏'}
          >
            <ConsoleIcon name="collapse" />
          </button>
        </div>

        <nav className="console-nav">
          {NAV_GROUPS.map((group) => (
            <div key={group.title} className="console-nav-group">
              {!collapsed && (
                <div className="console-nav-group-title">{group.title}</div>
              )}
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={`/console/${item.path}`}
                  className={({ isActive }) =>
                    `console-nav-link${isActive ? ' active' : ''}`
                  }
                  title={collapsed ? item.label : undefined}
                >
                  <ConsoleIcon name={item.icon} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>

      <div className="console-main">
        <header className="console-topbar">
          <h1 className="console-page-title">{pageTitle}</h1>
          <div className="console-topbar-actions">
            <button type="button" className="console-notify-btn" aria-label="通知">
              <ConsoleIcon name="bell" />
            </button>
            <div className="console-user">
              <span className="console-user-avatar">LC</span>
              <span>lvchunlc</span>
            </div>
          </div>
        </header>

        <div className="console-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const Console = () => (
  <Routes>
    <Route element={<ConsoleLayout />}>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<Overview />} />
      <Route path="playground" element={<Playground />} />
      <Route path="tokens" element={<Tokens />} />
      <Route path="logs" element={<Logs />} />
      <Route path="models" element={<Models />} />
      <Route path="recharge" element={<Recharge />} />
      <Route path="profile" element={<Profile />} />
      <Route path="wallet" element={<Wallet />} />
      <Route path="referral" element={<Referral />} />
      <Route path="*" element={<Navigate to="overview" replace />} />
    </Route>
  </Routes>
);

export default Console;
